import React from "react";

const Services_Info = () => {
  const services = [
    {
      img: "./assets/images/icons/blueprint.png",
      title: "Floor Plan",
      description:
        "Smart, space-efficient, and vastu-compliant designs for your dream home.",
      delay: 100,
    },
    {
      img: "./assets/images/icons/house1.png",
      title: "3D Elevation",
      description:
        "Realistic 3D exterior & interior designs that bring your vision to life.",
      delay: 200,
    },
    {
      img: "./assets/images/icons/approved.png",
      title: "Building Permit",
      description:
        "Hassle-free building approval and documentation handled by experts.",
      delay: 300,
    },
    {
      img: "./assets/images/icons/appraisal.png",
      title: "Estimation",
      description:
        "Accurate material & cost estimation to fit your budget — before construction begins.",
      delay: 400,
    },
    {
      img: "./assets/images/icons/property.png",
      title: "Completion Certificate",
      description:
        "Smooth final approvals and documentation once your project is done.",
      delay: 500,
    },
    {
      img: "./assets/images/icons/layout.png",
      title: "Layout & Site Planning",
      description:
        "Proper site utilization plans ensuring easy access, ventilation, and aesthetics.",
      delay: 600,
    },
    {
      img: "./assets/images/icons/modern-house.png",
      title: "Renovation & Remodeling",
      description:
        "Upgrade your existing space with smart redesigns and modern architecture concepts.",
      delay: 700,
    },
    {
      img: "./assets/images/icons/freelance.png",
      title: "Project Consultation",
      description:
        "Expert advice and technical guidance for smooth execution of your construction project.",
      delay: 800,
    },
    {
      img: "./assets/images/icons/home-and-checklist.png",
      title: "Quantity Take-off & Material Analysis",
      description:
        "Detailed reports of construction materials and quantities to avoid budget surprises.",
      delay: 900,
    },
  ];

  return (
    <div id="services_Info">
      <div className="mt-5 mb-5">
        <section className="features-1 mt-5">
      <div className="container">
        {/* Section Header */}
        <div className="row mb-5 align-items-center mt-5">
          <div
            className="col-lg-6"
            data-aos="fade-right"
            data-aos-delay="100"
          >
            <h2 className="font-weight-bold text-primary heading">
              Our Key Services
            </h2>
          </div>
          <div
            className="col-lg-6 text-lg-end"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <p>
              <a
                href="#"
                target="_blank"
                rel="noreferrer"
                className="btn btn-primary text-white py-3 px-4"
              >
                View All Services
              </a>
            </p>
          </div>
        </div>

        {/* Services List */}
        <div className="row">
          {services.map((service, index) => (
            <div
              className="col-6 col-lg-4 mb-4"
              key={index}
              data-aos="fade-up"
              data-aos-delay={service.delay}
            >
              <div className="box-feature text-center">
                <span className="custom-icons d-block mb-3">
                  <img
                    src={service.img}
                    alt={service.title}
                    style={{ width: "60px", height: "60px" }}
                  />
                </span>
                <h3 className="mb-3">{service.title}</h3>
                <p>{service.description}</p>
                <p>
                  <a href="#" className="learn-more">
                    Learn More
                  </a>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
    </div>
    </div>
  );
};

export default Services_Info;
